// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("bcs-app." + "4e648207e14b12d66636" + ".css");